/**
 * Per-question time tracking for ability tests (milliseconds).
 * @param {unknown} raw
 * @returns {Record<string, number>}
 */
export function normalizeQuestionTimings(raw) {
  if (!raw || typeof raw !== 'object') return {};
  const out = {};
  for (const [questionId, ms] of Object.entries(raw)) {
    const parsed = Number(ms);
    if (questionId && Number.isFinite(parsed) && parsed >= 0) {
      out[String(questionId)] = Math.round(parsed);
    }
  }
  return out;
}

/**
 * @param {Record<string, number>} timings
 * @param {string | null | undefined} questionId
 * @param {number | null | undefined} startedAt performance.now() or Date.now()
 * @returns {Record<string, number>}
 */
export function addElapsedToTimings(timings, questionId, startedAt) {
  if (!questionId || startedAt == null || !Number.isFinite(startedAt)) {
    return timings;
  }
  const elapsed = Math.round(Date.now() - startedAt);
  if (elapsed <= 0) return timings;
  return {
    ...timings,
    [questionId]: (timings[questionId] || 0) + elapsed
  };
}

/**
 * Include in-progress time without mutating committed timings.
 * @param {Record<string, number>} timings
 * @param {string | null | undefined} activeQuestionId
 * @param {number | null | undefined} startedAt
 */
export function snapshotQuestionTimings(timings, activeQuestionId, startedAt) {
  return addElapsedToTimings({ ...timings }, activeQuestionId, startedAt);
}
